<template>
  <div class="kemu-page">
    <el-dialog :model-value="visible" :close-on-click-modal="false" :show-close="false" destroy-on-close fullscreen>
      <template #header>
        <div class="header-left">
          <h4 class="header-title">考试结果</h4>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="isDaTi=false;closeWindow('visible', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-card class="mb10" shadow="never">
        <div class="title">
          <span class="mr10">{{info.kskmmc}}</span>
          <span>试卷满分：{{info.mffs || 0}}分</span>
        </div>
        <ul class="info">
          <li><span style="color: #909399;">姓名：</span>{{info.xm}}</li>
          <li><span style="color: #909399;">班级：</span>{{info.bjmc}}</li>
          <li><span style="color: #909399;">得分：</span>{{info.zf || 0}}分</li>
          <li><span style="color: #909399;">交卷时间：</span>{{info.tjsj}}</li>
        </ul>
      </el-card>
      <div style="display: flex;" v-loading="loading">
        <el-card shadow="never" style="width: calc(100% - 250px)">
          <div v-for="(stItem, stInd) in stData" :key="stInd">
            <p style="font-weight: bold;margin-bottom: 5px;">{{ stItem.th }}、<span v-for="(item, index) in zytxData.list" :key="index"><span v-if="stItem.txid===item.id" style="font-weight: bold;">{{ item.name }}</span></span>题</p>
            <div v-for="(item, index) in stItem.data" :key="index" :id="'' + stInd + index">
              <!-- 试题正文 -->
              <div class="zheng-wen">
                <div style="display: flex;align-items: center;">
                  <span>{{ index +1 }}、</span>
                  <span class="fen-zhi mr10">({{ item.fs || 0 }}分)</span>
                  <el-tag v-if="item.isDf" type="success">正确</el-tag>
                  <el-tag v-else type="danger">错误</el-tag>
                </div>
                <div style="white-space: pre-wrap; text-indent:0;margin-top: 5px;" v-html="item.stzw"></div>
              </div>
              <el-divider border-style="dotted" />
              <!-- 判断 -->
              <div v-if="item.txid === zytxData.panDuan">
                <ul class="da-an">
                  <li>你的答案：<span v-if="item.ksxq">{{item.ksxq.zd=='true'?'对':'错'}}</span></li>
                  <li>参考答案：<span v-if="item.pdtCkda">{{item.pdtCkda.pdtckda=='true'?'对':'错'}}</span></li>
                </ul>
              </div>
              <!-- 单选 -->
              <div v-else-if="item.txid === zytxData.danXuan">
                <ul class="xuan-xiang mb10">
                  <li v-for="(val, ind) in item.listXztxx" :key="ind" :label="val.xxbh"><span class="mr5">{{val.xxbh}}.</span><p style="white-space: pre-wrap; text-indent:0;" v-html="val.xxnr"></p></li>
                </ul>
                <ul class="da-an">
                  <li>你的答案：<span v-if="item.ksxq">{{ item.ksxq.zd }}</span></li>
                  <li>参考答案：<span v-for="(val, ind) in item.listXztCkda" :key="ind">{{ val.xxbh }}</span></li>
                </ul>
              </div>
              <!-- 多选 -->
              <div v-else-if="item.txid === zytxData.duoXuan">
                <ul class="xuan-xiang mb10">
                  <li v-for="(val, ind) in item.listXztxx" :key="ind" :label="val.xxbh"><span class="mr5">{{val.xxbh}}.</span><p style="white-space: pre-wrap; text-indent:0;" v-html="val.xxnr"></p></li>
                </ul>
                <ul class="da-an">
                  <li>你的答案：<span v-if="item.ksxq">{{ item.ksxq.zd }}</span></li>
                  <li>参考答案：<span v-for="(val, ind) in item.listXztCkda" :key="ind">{{ (ind>0?',':'') + val.xxbh}}</span></li>
                </ul>
              </div>
              <!-- 其他 -->
              <div v-else>
                <ul class="da-an">
                  <li>你的答案：<p style="white-space: pre-wrap; text-indent:0;" v-if="item.ksxq" v-html="item.ksxq.zd"></p></li>
                  <li>标准答案：<p style="white-space: pre-wrap; text-indent:0;" v-if="item.ksxq" v-html="item.ksxq.zd"></p></li>
                </ul>
              </div>
              <el-divider />
            </div>
          </div>
        </el-card>
        
        <el-affix :offset="140" style="width: 250px; margin-left: 20px;">
          <el-card class="dao-hang" shadow="never">
            <div v-for="(item, index) in stData" :key="index">
              <p style="font-weight: bold;margin-bottom: 5px;">
                {{ item.th }}、
                <span v-for="(val, ind) in zytxData.list" :key="ind">
                  <span v-if="item.txid === val.id" style="font-weight: bold;">{{ val.name }}</span>
                </span>题
              </p>
              <el-link v-for="(val, v) in item.data" :key="v" :underline="false" :href="'#' + index + v"
                :style="val.isDf ? 'background-color: #67C23A;color: #FFF' : 'background-color: #F56C6C;color: #fff'"
                >{{ v + 1 }}</el-link>
            </div>
          </el-card>
        </el-affix>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue'
import { actionGet, closeWindow } from '@/api/common.js'
import { getTiXing } from '@/utils/zidianmeiju.js'
import { toChinesNum } from '@/utils/index.js'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({ visible: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:visible', 'ReturnData'])

const loading = ref(false)
const info = ref({}) // 试卷详情
const stData = ref([{}]) // 试题列表
const zytxData = ref({ list: [] }) // 题型

const initList = (id) => {
  loading.value = true
  zytxData.value = getTiXing()
  let dest = []
  actionGet({ url: `/api/v2/wangluojiaoxue/xuesheng/kaoshi/${id}`, data: {} }).then((res) => {
    if (res.code === 200) {
      info.value.mffs = res.data.sjmf
      info.value.zf = res.data.zf
      dest = res.data.listShiTi
      const map = {}
      stData.value = []
      for (let i = 0; i < dest.length; i++) {
        const ai = dest[i]
        if (ai.ksxq) {
          ai.isDf = ai.ksxq.fs > 0
        }
        if (!map[ai.txid]) {
          stData.value.push({ txid: ai.txid, th: null, data: [ai] })
          map[ai.txid] = ai
        } else {
          for (let j = 0; j < stData.value.length; j++) {
            const dj = stData.value[j]
            if (dj.txid === ai.txid) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      stData.value.map((item, index) => { item.th = toChinesNum(index + 1); return item })
      console.log(stData.value)
      loading.value = false
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.visible,
  () => {
    if (props.visible) {
      info.value = props.row
      initList(props.row.id)
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.kemu-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-card {
    margin: 10px 0;
  }
}
.title {
  font-size: 1.3em;
  margin-bottom: 5px;
}
.info {
  display: flex;
  li + li {
    margin-left: 20px;
  }
}

.da-an {
  color: #303133;
  background-color: rgb(244, 244, 245);
  padding: 10px;
  li {
    display: flex;
  }
}
.xuan-xiang {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #303133;
  li {
    display: flex;
  }
}
  .dao-hang {
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    flex-direction: column;
    border-radius: 10px;

    :deep(.el-link) {
      margin: 4px;
      width: 30px;
      height: 30px;
      border-radius: 4px;
      background-color: #e9e9eb;
      box-shadow: 1px 1px 0px 0 rgb(0 0 0 / 30%)
    }
  }

</style>
